import React, { useState } from 'react';

import './OpenSourceLibraries.scss';
import licenses from './licenses.json';

type License = {
  license: string;
  name: string;
  url: string;
};

const OpenSourceLibraries = () => {
  const [selectedLicense, setSelectedLicense] = useState<License | null>(null);

  const showLicense = (license: License) => {
    setSelectedLicense(license);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const goBack = () => {
    setSelectedLicense(null);
  };

  return (
    <div className="bg-gray-100 text-gray-800 min-h-screen p-4">
      {!selectedLicense ? (
        <div
          id="repoList"
          className="max-w-2xl mx-auto mt-10 bg-white rounded-lg shadow-md p-6"
        >
          <h2 className="text-2xl font-bold mb-4 text-gray-700">
            Open Source Libraries
          </h2>
          <ul className="flex flex-col w-full">
            {licenses.map((license: License, index) => (
              <li
                key={index}
                className="table-cell"
                onClick={() => showLicense(license)}
              >
                <span className="text-gray-700">{license.name}</span>
                <span className="arrow">➔</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div
          id="licenseSection"
          className="fixed inset-0 bg-white p-6 overflow-y-auto"
        >
          <button className="back-button" onClick={goBack}>
            ← Back
          </button>
          <a
            id="repoLink"
            href={selectedLicense.url}
            className="text-blue-600 hover:underline block mt-4"
          >
            {selectedLicense.name}
          </a>
          <pre
            id="licenseText"
            className="text-sm whitespace-pre-wrap text-gray-800 mt-4"
          >
            {selectedLicense.license.replace(/\\n/g, '\n')}
          </pre>
        </div>
      )}
    </div>
  );
};

export default OpenSourceLibraries;
